import http from "../utils/http";


// 摄像头类型下拉框
export function getCameraType() {
    return http({
        method: 'GET',
        url: '/system/xcwsCamera/cameratype',
    });
}

// 子食堂-》视频列表 摄像头绑定列表
export function getCameraList(data) {
    return http({
        method: 'GET',
        url: '/system/xcwsCamera/camera/list',
        params: data,
    });
}

// 子食堂列表
export function getSubList(data) {
    return http({
        method: 'GET',
        url: '/system/xcwsCamera/sub/list',
        params: data,
    });
}

// 子食堂-》视频列表 绑定/解绑
export function setBind(data) {
    return http({
        method: 'post',
        url: '/system/xcwsCamera/bind',
        data,
    });
}

// 子食堂-》直播列表 主体摄像头列表
export function getLiveCameraList(data) {
    return http({
        method: 'get',
        url: '/system/xcwsCamera/live/list',
        params: data,
    });
}